import { Modal } from '@fozito/common-ui';
import { Form } from 'antd';
import QRPaymentDetail from 'modules/POS/PaymentDetails/QRPaymentDetail';
import { IBillInfoResData } from 'modules/POS/services/types/bill';
import { ICashierOtherPayment } from 'modules/POS/services/types/payment';
import shopService from 'modules/shop/services';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';

const FormStyled = styled(Form)`
height: 100%;
`;
type Props = {
  onDone: (otherMethod: string) => void;
  onCancel: () => void;
};
type Ref = {
  open: (data: {
    amount: number,
    detail: IBillInfoResData,
    paymentType: string,
    items: {
      name: string;
      price: number;
      quantity: number;
    }[],
  }) => void;
};
export const useModalQRPaymentRef = () => useRef<Ref>(null);
const ModalQRPayment = forwardRef<Ref, Props>(({ onDone, onCancel }, ref) => {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const payments = shopService.selectors.paymentOthers();

  const onClose = () => setOpen(false);
  const handleFinish = async (values: any) => {
    const data = values as { amount: number, detail: IBillInfoResData, paymentType: string };

    if (!open) return;
    const payment: ICashierOtherPayment = {
      amount: data.amount,
      paymentType: data.paymentType,
      otherMethod: data.paymentType,
    };
    onDone(payment.otherMethod || '');
    setOpen(false);
  };

  const onOpen: Ref['open'] = async (data) => {

    form.setFieldsValue(data);
    setOpen(true);
  };
  const _onCancel = () => {
    setOpen(false);
    onCancel();
  };
  useImperativeHandle(ref, () => ({
    open: onOpen
  }));

  return (
    <Modal title='Card' open={!!open} onClose={onClose} width={'100vw'} styles={{
      content: { height: '100vh', boxShadow: 'none' },
      header: { display: 'none' },
      body: { height: '100vh', maxHeight: 'unset' },
      wrapper: { background: '#fff' },
      mask: { display: 'none' }
    }}>
      <FormStyled form={form} onFinish={handleFinish}>
        <Form.Item name={'billId'} noStyle />
        <Form.Item name={'detail'} noStyle />
        <Form.Item name={'amount'} noStyle />
        <Form.Item name={'items'} noStyle />
        <Form.Item name={'paymentType'} noStyle />
        <Form.Item noStyle shouldUpdate>
          {({ getFieldValue }) => {
            const detail = getFieldValue('detail');
            const items = getFieldValue('items');
            const amount = getFieldValue('amount');
            const paymentType = getFieldValue('paymentType');
            const activePayment = payments.find(o => o.methodType === paymentType);
            return (
              <QRPaymentDetail
                date={detail?.createdDated || ''}
                customerName={detail?.customerName || 'Unknown Customer'}
                customerPhone={detail?.customerPhone}
                ticketNumber={detail?.ticketNumber || 0}
                items={items}
                subtotal={detail?.subTotal || 0}
                cardFee={detail?.cardFee || 0}
                saleTax={detail?.saleTax || 0}
                useTax={detail?.useTax || 0}
                discount={detail?.discount || 0}
                specifyAmount={amount}
                onCancel={_onCancel}
                onConfirm={() => form.submit()}
                qrCodeImg={activePayment?.qrCode}
                QRName={activePayment?.methodName}
              />
            );
          }}
        </Form.Item>
      </FormStyled>
    </Modal>
  );
});
ModalQRPayment.displayName = 'ModalQRPayment';
export default ModalQRPayment;